import { render, staticRenderFns } from "./CustomMessage.vue?vue&type=template&id=e371cef6&"
import script from "./CustomMessage.vue?vue&type=script&lang=js&"
export * from "./CustomMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports